import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Banner from '../../atoms/Banner/Banner';
import Image from '../../atoms/Image';
import ContentBox from '../../molecules/ContentBox';

const bd = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'Visit Way',
  text1: 'Best of the Best’s BI shows a strong will to nurture the best information security leaders.',
};

export default function VisitWayPage() {
  const classes = useStyles();

  const handleMapBtn = () => {
    window.open(
      'https://www.google.co.kr/maps/place/543-1+Gasan-dong,+Geumcheon-gu,+Seoul/@37.4798222,126.8773768,17.05z/data=!4m5!3m4!1s0x357b61fcec602951:0x3030ea201d2c48ef!8m2!3d37.4796508!4d126.8770822?hl=en'
    );
  };

  return (
    <Box className={classes.root}>
      <Banner bannerData={bd} />
      <ContentBox>
        <Box className={classes.mapBox}>
          <Image id='img' alt='map' className={classes.map} src='/images/visitway_map.png' />
          <Box onClick={handleMapBtn} className={classes.mapBtn}>
            MAP -{`>`}
          </Box>
        </Box>
        <Box className={classes.addrBox}>
          <Box className={classes.addr}>Daeseong Dipolis Building A (Gasan Digital Complex Station, 8-minute walk from Exit 6)</Box>
          <Box className={classes.addr}>27th floor, Gasan Daeseong Dipolis Building A, 606 Seobu Saet-gil, Geumcheon-gu, Seoul</Box>
        </Box>
        <Box className={classes.bottomBox}>
          <Box className={classes.phoneBox}>
            <Box className={classes.phoneTitle}>{`CALL & FAX`}</Box>
            <Box className={classes.phone}>02-869-8301(#9821)</Box>
            <Box className={classes.phone}>02-565-6052</Box>
          </Box>
        </Box>
      </ContentBox>
      <Box className={classes.vigilance}>Vigilance</Box>
      <ContentBox marginTop='64px'>
        <Box className={classes.bottomContainer}>
          <Box className={classes.transportation}>
            <Box className={classes.imgBox}>
              <Image className={classes.bImg} src='/images/icon/bus icon2x.png' alt='Bus Image' />
              <Box className={classes.backBox} />
            </Box>
            <Box className={classes.bBox}>
              <Box className={classes.bTitle}>BUS</Box>
              <Box className={classes.bContent}>Nomar no.21</Box>
              <Box className={classes.bContent}>Trunk no.571, no.652</Box>
              <Box className={classes.bTitle}>STATION</Box>
              <Box className={classes.bContent}>Digital Complex 3 World Venture Center</Box>
            </Box>
          </Box>
          <Box className={classes.transportation}>
            <Box className={classes.imgBox}>
              <Image className={classes.bImg} src='/images/icon/subway 96@2x.png' alt='Subway Image' />
              <Box className={classes.backBox} />
            </Box>
            <Box className={classes.bBox}>
              <Box className={classes.bTitle}>SUBWAY</Box>
              <Box className={classes.bContent}>line 7</Box>
              <Box className={classes.bContent}>&nbsp;</Box>
              <Box className={classes.bTitle}>STATION</Box>
              <Box className={classes.bContent}>Get off at Gasan Digital Complex Station (Exit 6) and walk for 8 minutes</Box>
            </Box>
          </Box>
        </Box>
      </ContentBox>
    </Box>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '200px',
  },
  mapBox: {
    display: 'flex',
    position: 'relative',
    alignItems: 'flex-end',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },
  map: {
    maxWidth: '883px',
    width: '70%',
    boxShadow: `20px 20px 3px #f4f6f9`,
    '@media only screen and (max-width: 768px)': {
      width: '100%',
      marginBottom: '40px',
    },
    '@media only screen and (max-width: 425px)': {
      width: '100%',
    },
  },

  mapBtn: {
    border: '1px solid',
    width: '180px',
    minWidth: '180px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 20px',
    boxSizing: 'border-box',
    backgroundColor: '#f4f6f9',
    marginLeft: '60px',
    marginBottom: '-20px',
    cursor: 'pointer',
    '@media only screen and (max-width: 768px)': {
      marginRight: '-20px',
    },
    '@media only screen and (max-width: 425px)': {
      minWidth: '120px',
      width: '120px',
      height: '32px',
      fontSize: '12px',
      marginRight: '-8px',
    },
  },
  addrBox: {
    margin: '40px 0',
    padding: '0 20px',
    boxSizing: 'border-box',
  },
  addr: {
    fontSize: '20px',
    marginBottom: '12px',
    '@media only screen and (max-width: 768px)': {
      maxWidth: '300px',
      fontSize: '16px',
    },
    '@media only screen and (max-width:425px)': {
      fontSize: '12px',
    },
  },
  bottomBox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    marginBottom: '104px',
  },
  phoneBox: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: '#f4f6f9',
    maxWidth: '488px',
    width: '100%',
    padding: '32px 40px 20px 40px',
    boxSizing: 'border-box',
    alignItems: 'flex-end',
    '@media only screen and (max-width:425px)': {
      padding: '16px 20px 10px 20px',
    },
  },
  phoneTitle: {
    position: 'absolute',
    backgroundColor: theme.color.black,
    width: '100%',
    maxWidth: '188px',
    fontSize: '20px',
    color: theme.color.white,
    display: 'flex',
    justifyContent: 'center',
    padding: '8px 20px',
    boxSizing: 'border-box',
    top: '-20px',
    '@media only screen and (max-width:425px)': {
      fontSize: '16px',
    },
  },

  phone: {
    margin: '8px 0',
    fontSize: '16px',
    '@media only screen and (max-width:425px)': {
      fontSize: '12px',
    },
  },
  vigilance: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.color.black,
    color: theme.color.white,
    fontSize: '24px',
    justifyContent: 'center',
    padding: '6px 0',
    textDecoration: 'underline',
    fontWeight: '600',
    '@media only screen and (max-width:768px)': {
      fontSize: '16px',
    },
  },

  bottomContainer: {
    display: 'flex',
    justifyContent: 'center',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  transportation: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '300px',
    margin: '0 48px',
    '@media only screen and (max-width: 768px)': {
      marginBottom: '40px',
    },
  },
  imgBox: {
    position: 'relative',
    padding: '24px 0 0 16px',
    boxSizing: 'border-box',
  },
  bImg: {
    width: '70%',
    maxWidth: '200px',
    marginBottom: '16px',
  },
  backBox: {
    position: 'absolute',
    backgroundColor: '#f4f6f9',
    width: '124px',
    height: '124px',
    top: '0',
    left: '0',
    zIndex: '-1',
  },
  bBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingLeft: '16px',
    boxSizing: 'border-box',
  },
  bTitle: {
    fontSize: '20px',
    fontWeight: '600',
    margin: '12px 0',
    '@media only screen and (max-width:425px)': {
      fontSize: '16px',
    },
  },
  bContent: {
    fontSize: '16px',
    marginBottom: '8px',
    '@media only screen and (max-width:425px)': {
      fontSize: '12px',
    },
  },
}));
